import { Box, Checkbox, Group, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export default function PathInspectionPolicy() {
  const tBooking = useTranslations('booking');
  const { control } = useFormContext();

  return (
    <Box bg={'#F2F4F8'} px={'md'} py={rem(8)} style={{ borderRadius: rem(8) }}>
      <Controller
        control={control}
        name="inspection_policies"
        render={({ field: { onChange, value } }) => (
          <Checkbox.Group
            label={tBooking('location.recipient_can')}
            key={'inspection_policies'}
            value={value}
            onChange={(e) => onChange(e)}
            styles={(theme) => ({
              label: {
                color: theme.colors.neutral[5],
                fontSize: rem(12),
                lineHeight: rem(16),
                fontWeight: 600,
              },
            })}
          >
            <Group mt={rem(4)}>
              <Checkbox
                value="ALLOW_TO_INSPECT_GOODS"
                label={tBooking('location.check')}
                styles={{
                  label: {
                    fontSize: rem(14),
                    lineHeight: rem(20),
                    fontWeight: 500,
                  },
                }}
              />
              <Checkbox
                value="ALLOW_TO_TRY_GOODS"
                label={tBooking('location.test')}
                styles={{
                  label: {
                    fontSize: rem(14),
                    lineHeight: rem(20),
                    fontWeight: 500,
                  },
                }}
              />
            </Group>
          </Checkbox.Group>
        )}
      />
    </Box>
  );
}
